/**
 * 机器人配置
 */

import { isBp, isAdV2 } from 'Src/util/tool'

// 机器人配置
window.SCENARIZED_HELP = {
  // 路径对应场景化模块
  pathModules: [{
    path: '/pages/reporter',
    level: 1,
    id: '6548318567723433987',
    title: '数据报告',
    noDropZoneOnRight: {
      topToBase: -200, // px为单位
      base: 100, // vh为单位
      bottomToBase: 248 // px为单位
    }
  }],
  excludePath: [
    '/pages/toolbox/batch_edit.html',
    '/pages/toolbox/batch_edit_audience.html',
    '/pages/toolbox/word-bid.html',
    '/pages/toolbox/batch_privative_set.html'
  ],
  // 场景化帮助调起配置
  callConfig: {
    DRSPHZM: {
      level: 3,
      id: '6763442602080469005',
      label: '如何获取合作码',
      title: '如何获取合作码'
    },
    DYDSP: {
      level: 3,
      id: '6763445552861413380',
      label: '如何复制抖音视频链接',
      title: '如何复制抖音视频链接'
    },
    TFLX: {
      level: 3,
      id: '6548320369164419085',
      label: '什么是投放类型',
      title: '推广目的'
    },
    TGYS: {
      level: 3,
      id: '6548320727534141454',
      label: '什么是广告组预算',
      title: '推广预算'
    },
    DYHSZ: {
      title: '抖音号设置'
    },
    TFFW: {
      level: 3,
      id: '6548723839612747790',
      label: '什么是投放范围',
      title: '投放范围'
    },
    DYPP: {
      level: 3,
      id: '6688618551630102531',
      label: '什么是地域匹配',
      title: '商品定向'
    },
    TFMB: {
      level: 3,
      id: '6548723912300036109',
      label: '什么是投放目标',
      title: '投放目标'
    },
    BJLJ: {
      level: 3,
      id: '6548723981573160974',
      label: '什么是编辑链接',
      title: '编辑链接'
    },
    YHDX: {
      level: 3,
      id: '6548724047117549582',
      label: '什么是用户定向',
      title: '用户定向'
    },
    YXYCJ: {
      level: 3,
      id: '6548724124242411534',
      label: '什么是预算与出价',
      title: '预算与出价'
    },
    GGW_YX: {
      level: 3,
      id: '6642234255910895624',
      label: '什么是优选广告位',
      title: '优选广告位'
    },
    GGW_ZD: {
      level: 3,
      id: '6548707157452259332',
      label: '什么是指定广告位',
      title: '创建/修改创意'
    },
    CXHCY: {
      title: '程序化创意'
    },
    GGW_CJ: {
      level: 3,
      id: '6642234738398461959',
      label: '什么是场景广告位',
      title: '按场景指定位置'
    },
    FLBQ: {
      level: 3,
      id: '6642235681705820168',
      label: '什么是分类与标签',
      title: '创意分类与创意标签的作用与区别？'
    },
    GGW_AWEME: {
      level: 3,
      id: '6642234606038810638',
      label: '什么是抖音广告位',
      title: '抖音广告位'
    },
    GGW_NOVELAPP: {
      level: 3,
      id: '1707164589394947',
      label: '什么是番茄小说广告位',
      title: '番茄小说广告位'
    },
    GGW_HOTSOON: {
      level: 3,
      id: '6642234526971985928',
      label: '什么是火山小视频广告位',
      title: '火山小视频广告位'
    },
    GGW_VIDEO_RESULT: {
      level: 3,
      id: '6642234453991096333',
      label: '什么是西瓜视频广告位',
      title: '西瓜视频广告位'
    },
    GGW_UNION: {
      level: 3,
      id: '6642234668567494670',
      label: '什么是穿山甲广告位',
      title: '穿山甲广告位'
    },
    GGW_UNION_SMART_GAME: {
      level: 3,
      id: '6734605740633227276',
      label: '什么是穿山甲-精选休闲游戏',
      title: '穿山甲-精选休闲游戏'
    },
    GGW_JRTT: {
      level: 3,
      id: '6642234372797759496',
      label: '什么是今日头条广告位',
      title: '今日头条广告位'
    },
    DPA: {
      level: 3,
      id: '6555766865132519428',
      label: '商品库',
      title: 'DPA'
    },
    DIMENSTION: {
      level: 3,
      id: '6714470838189424644',
      label: '细分',
      title: '细分详解介绍'
    },
    SPML: {
      level: 3,
      id: '6727443634968330244',
      label: '商品目录',
      title: '商品目录'
    },
    JSXZ: {
      level: 3,
      id: '6579475272075051016',
      label: '极速下载',
      title: '极速下载服务'
    },
    YYXZZHMB: {
      level: 3,
      id: '6652249686226763790',
      label: '应用下载转化目标',
      title: '转化跟踪'
    },
    ZHGZFS: {
      level: 3,
      id: '6792757167398060039',
      label: '转化跟踪方式',
      title: '转化跟踪方式'
    },
    DYH: {
      level: 3,
      id: '6792759483022966797',
      label: '抖音号',
      title: '关联抖音号'
    },
    GAME: {
      level: 3,
      id: '6808357804923944968',
      label: '游戏礼包码',
      title: '游戏礼包码'
    }
  }
}

window.SCENARIZED_HELP.pathModule = window.SCENARIZED_HELP.pathModules.filter(function (obj) {
  return window.location.href.indexOf(obj.path) >= 0
})[0]

// 机器人默认配置
const advertiser = (window.GLOBAL_VAR && GLOBAL_VAR.advertiser) || {}
export const botConfig = isBp() ? {
  platToken: 'a16bd465-5996-11eb-821c-825697302cf6',
  version: 'v5',
  getSignatureUrl: `//${window.location.host}/platform/api/v1/tool/sdk_auth_check/`,
  user: {
    name: GLOBAL_VAR.coreUser.adminName,
    id: GLOBAL_VAR.coreUser.id
  },
  chatName: '智能客服',
  entryOptions: {
    // 使用白色主题
    theme: 'white',
    // 修改入口位置
    bottom: 96,
    zIndex: 999
  },
  getSignatureHeaders: {
    'X-CSRFToken': $.cookie('csrftoken')
  },
  startQuestion: window.SCENARIZED_HELP.pathModule ? window.SCENARIZED_HELP.pathModule.title : ''
} : {
  platToken: 'cf3cc435-71bc-11eb-8b24-deaad4c14cb4',
  version: 'v5',
  getSignatureUrl: `//${window.location.host}/platform/api/v1/tool/sdk_auth_check/?aadvid=${advertiser.id || ''}`,
  user: {
    name: GLOBAL_VAR.coreUser.adminName,
    id: GLOBAL_VAR.coreUser.id
  },
  chatName: '巨量问问',
  entryOptions: {
    // 使用白色主题
    theme: 'wenwen',
    // 修改入口位置
    bottom: 96,
    zIndex: 999
  },
  getSignatureHeaders: {
    'X-CSRFToken': $.cookie('csrftoken')
  },
  startQuestion: window.SCENARIZED_HELP.pathModule ? window.SCENARIZED_HELP.pathModule.title : ''
}

export const defaultSurveyConfig = isAdV2() ? {
  appKey: 'b3428656817f437ad162a9caf95f1b4e001ba44c',
  channel: 'cn',
  language: 'zh_CN',
  platform: 'desktop',
  taskListToDisableAuto: ['7083410213138595877'],
  taskIdBannerMapping: {
    '7083410213138595877': {
      staticImg: null, // 第二次展开后显示
      gif: null // 首次展开时显示
    }
  },
  id: '7083410213138595877',
  taskShowConfMap: {
    // 投放平台问卷
    '7083410213138595877': {
      hideEntry: true
    }
  },
  debug: false
} : {
  appKey: '33a136b7bbc802657f1fadf62fc6a5724c157702',
  channel: 'cn',
  language: 'zh_CN',
  platform: 'desktop',
  taskListToDisableAuto: ['6769094744803901454'],
  taskIdBannerMapping: {
    // 可以设置全局头图，对所有调研生效，图片地址后续删除，删除请咨询刘宏清
    // __global__: {
    //   staticImg: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/37d8e0a0591643198228c888d8205828~tplv-yvqzo4lhg5-image.image'), // 第二次展开后显示
    //   gif: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/37d8e0a0591643198228c888d8205828~tplv-yvqzo4lhg5-image.image') // 首次展开时显示
    // },
    // 或针对某一个taskId设置
    '6769094744803901454': {
      staticImg: null, // 第二次展开后显示
      gif: null // 首次展开时显示
    }
  },
  taskShowConfMap: {
    // 投放平台问卷
    '6769094744803901454': {
      hideEntry: true
    },
    // 穿山甲
    '6897784029194485763': {
      entryImg: {
        url: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/7aa4685587b447d8af5fbba687a9861d~tplv-yvqzo4lhg5-image.image'),
        height: '48px',
        width: '48px',
        // fixed定位
        right: '0',
        top: '200px'
      }
    }
  },
  debug: false
}

export const bpSurveyConfig = {
  appKey: '1446507f510a8f66a1445a7b3b468c510c2be332',
  channel: 'cn',
  language: 'zh_CN',
  platform: 'desktop',
  id: '6916734918055690248',
  taskListToDisableAuto: ['6916734918055690248'],
  taskShowConfMap: {
    // 投放平台问卷
    '6916734918055690248': {
      hideEntry: true
    }
  },
  debug: false
}

export const reportStartQuestionList = {
  advertiser: {
    key: '数据报表',
    wolongId: [
      195011,
      238483,
      195110,
      238486,
      238491
    ]
  },
  campaign: {
    key: '数据报表',
    wolongId: [
      195011,
      238483,
      195110,
      238486,
      238491
    ]
  },
  ad: {
    key: '数据报表',
    wolongId: [
      195011,
      238483,
      195110,
      238486,
      238491
    ]
  },
  creative: {
    key: '创意报表',
    wolongId: [
      195012,
      238499,
      238501
    ]
  },
  material_material: {
    key: '创意报表',
    wolongId: [
      195012,
      238499,
      238501
    ]
  },
  keyword: {
    key: '关键词报表',
    wolongId: [
      193538
    ]
  },
  audience_basic_population: {
    key: '受众报表',
    wolongId: [
      238502,
      195017,
      195013,
      195108
    ]
  },
  dmp: {
    key: '人群包报表',
    wolongId: [
      238503,
      238504,
      238505,
      238506,
      238507
    ]
  },
  video: {
    key: '视频报表',
    wolongId: [
      222954
    ]
  },
  landing_page: {
    key: '落地页报表',
    wolongId: [
      238514,
      238515,
      238511,
      238516,
      195015
    ]
  },
  webcast_room: {
    key: '直播报表',
    wolongId: [
      238510,
      238509,
      238508
    ]
  },
  business_account_overview: {
    key: '企业号报表',
    wolongId: [
      222987

    ]
  },
  search_words: {
    key: '搜索词报表',
    wolongId: [
      193538,
      238518
    ]
  },
  dpa: {
    key: '产品目录',
    wolongId: []
  },
  creative_procedural: {
    key: '程序化创意',
    wolongId: []
  },
  product: {
    key: '产品报表',
    wolongId: []
  },
  car: {
    key: '汽车报表',
    wolongId: []
  }
}
